import { render, staticRenderFns } from "./Risks2.vue?vue&type=template&id=f75a0326"
import script from "./Risks2.vue?vue&type=script&lang=js"
export * from "./Risks2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports